var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoIconSquare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 75.6 75.6"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 37.8,
  cy: 62.63,
  r: 11.33,
  fill: "#fcb415"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fdda7f",
  d: "M58.42 33.77 37.8 17.7 58.42 1.64z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcb415",
  d: "M58.42 33.77 37.8 48.58 17.18 33.77 37.8 17.7z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#36beb6",
  d: "M17.18 33.77V1.64h41.24z"
})));
export { SvgLogoIconSquare as ReactComponent };
export default __webpack_public_path__ + "fe1fc21019252db5935a24f1e78b71c1.svg";